import classNames from 'classnames'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { Body2, Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { useWindowResize } from '@utils/domUtils'

import { AppMarketQRCode } from '@global/appMarketLink/desktop/AppMarketQRCode'
import { AppMarketLink } from '@global/appMarketLink/mobile/AppMarketLink'
import { Notification } from '@global/notification/notification'

import { TwoFactorAuthLocationState, useTwoFactorAuth } from './useTwoFactorAuth'
import { useTwoFactorAuthGoBackProps } from './useTwoFactorAuthGoBackProps'

import styles from './TwoFactorAuthPage.module.scss'

export const TwoFactorAuthErrorPage: React.FC = () => {
  const navigate = useNavigate()
  const { openRecoveryCodeModal, stateChecker } = useTwoFactorAuth()
  const { t } = useTranslation()
  const isMobile = useWindowResize()
  const locationState = useLocation().state as TwoFactorAuthLocationState

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => stateChecker().effect(), stateChecker().dependants)

  const goBackProps = useTwoFactorAuthGoBackProps(
    locationState?.twoFactorAuthData?.twoFactorAuthEvent ?? ''
  )

  return (
    <div className={styles.topWrapper}>
      <div className={styles.wrapper}>
        {!isMobile && (
          <div className={styles.qrCode}>
            <AppMarketQRCode />
          </div>
        )}
        <div className={classNames(styles.inner, 'pt-0')}>
          <div className='my-2'>
            <Button.Ghost
              size='md'
              iconLeft={ArrowIcon.Left}
              onClick={() =>
                navigate(goBackProps.path, goBackProps.state ? { state: goBackProps.state } : {})
              }
            >
              {goBackProps.text}
            </Button.Ghost>
          </div>

          <div className={classNames(styles.title, 'my-2')}>
            <Heading6 medium>{t('Sign up.Two-Factor Authentication')}</Heading6>
          </div>
          <Notification
            wrapperClassName={'my-0'}
            variant={'danger'}
            subtitle={t('TwoFactorAuth.Youve reached the maximum amount of verification attempts')}
          />
          <Body2 className={classNames(styles.notice, 'mt-0')}>
            {t('TwoFactorAuth.To restore access to your Client Area')}
          </Body2>
          <Button.Ghost onClick={openRecoveryCodeModal} size='md'>
            {t('Sign up.Enter recovery code')}
          </Button.Ghost>
        </div>
        <AppMarketLink />
      </div>
    </div>
  )
}
